import { render } from "./English.vue?vue&type=template&id=cfc24e64&scoped=true"
import script from "./English.vue?vue&type=script&lang=js"
export * from "./English.vue?vue&type=script&lang=js"

import "./English.vue?vue&type=style&index=0&id=cfc24e64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfc24e64"]])

export default __exports__